module.exports = __webpack_public_path__ + "img/selected_cabinet_on.a58b4fbe.svg";